export enum AppConfigEnvKey {
    REACT_APP_BASE_URL = "REACT_APP_BASE_URL",
    REACT_APP_CLIENT_ID = "REACT_APP_CLIENT_ID",
    REACT_APP_ADB2C_TENANT_ID = "REACT_APP_ADB2C_TENANT_ID",
    REACT_APP_URI_REDIRECT = "REACT_APP_URI_REDIRECT",
    REACT_APP_AD_SCOPE_TEMPLATE_MANAGER = "REACT_APP_AD_SCOPE_TEMPLATE_MANAGER",
    REACT_APP_AD_SCOPE_DOCENTE = "REACT_APP_AD_SCOPE_DOCENTE",
    REACT_APP_AD_SCOPE_DOCENTEREPORT = "REACT_APP_AD_SCOPE_DOCENTEREPORT",
    REACT_APP_PROXY_MICROSERVICE_DOCENTE_URL = "REACT_APP_PROXY_MICROSERVICE_DOCENTE_URL",
    REACT_APP_PROXY_MICROSERVICE_TEMPLATEMANAGER_URL = "REACT_APP_PROXY_MICROSERVICE_TEMPLATEMANAGER_URL",
    REACT_APP_PROXY_MICROSERVICE_DOCENTE_REPORT_URL = "REACT_APP_PROXY_MICROSERVICE_DOCENTE_REPORT_URL",
}

class AppConfig {
    private env = process.env;

    private readonly fallback: Record<AppConfigEnvKey, string> = {
        REACT_APP_BASE_URL: "https://api-dev.grupomarista.org.br/public/es/",
        REACT_APP_CLIENT_ID: "0533d500-7e4e-4347-8c1d-2c40f073fff6",
        REACT_APP_ADB2C_TENANT_ID: "8a1ef6c3-8324-4103-bf4a-1328c5dc3653",
        REACT_APP_URI_REDIRECT:
            "https://agendadocentedevqablob.z15.web.core.windows.net/",
        REACT_APP_AD_SCOPE_TEMPLATE_MANAGER:
            "api://templatemanager-api/.default",
        REACT_APP_AD_SCOPE_DOCENTE: "api://docente-api/.default",
        REACT_APP_AD_SCOPE_DOCENTEREPORT:
            "api://docentereport-api/DocenteReport-API.ReadWrite",
        REACT_APP_PROXY_MICROSERVICE_DOCENTE_URL:
            "https://api-dev.grupomarista.org.br/public/es/docente/v1",
        REACT_APP_PROXY_MICROSERVICE_TEMPLATEMANAGER_URL:
            "https://api-dev.grupomarista.org.br/public/es/template-manager/v1",
        REACT_APP_PROXY_MICROSERVICE_DOCENTE_REPORT_URL:
            "https://api-dev.grupomarista.org.br/public/es/docente-report/v1",
    };

    get(key: AppConfigEnvKey): string {
        let value = this.env[key];

        if (!value) {
            value = this.fallback[key]; // eslint-disable-next-line no-console

            // eslint-disable-next-line no-console
            console.warn(
                `[AppConfig] environment variable '${key}' not found, applying fallback value`
            );
        }

        return value ?? "";
    }
}

export const appConfig = new AppConfig();
